import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { Params } from '@angular/router';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, tap } from 'rxjs';
import { filter } from 'rxjs/operators';

import { AimoCMSBannerComponent } from '../../../model/cms.model';
import { GTMContentType, GTMCreativeSlot, GTMEventCode } from '../../../service/gtm/aimo-gtm.model';
import { AimoGtmService } from '../../../service/gtm/aimo-gtm.service';
import { SafeUrlPipe } from '../utils/safe-html/aimo-pipes';

@Component({
    selector: 'aimo-banner',
    templateUrl: './aimo-banner.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AimoBannerComponent implements OnInit {
    @Input() banner: AimoCMSBannerComponent;

    componentData$: Observable<AimoCMSBannerComponent>;
    scrollInterval: any;
    @ViewChild('bannerWrapper', { static: false })
    private bannerWrapper: ElementRef<HTMLDivElement>;

    constructor(
        protected component: CmsComponentData<AimoCMSBannerComponent>,
        protected gtmService: AimoGtmService,
        public safeUrlPipe: SafeUrlPipe,
    ) {}

    ngOnInit(): void {
        this.componentData$ = this.component.data$.pipe(
            filter(Boolean),
            tap((banner) => {
                this.isScrolledIntoView(banner);
            }),
        );
    }

    isScrolledIntoView(banner: AimoCMSBannerComponent) {
        this.scrollInterval = setInterval(
            () =>
                AimoGtmService.triggerInViewEvent(this.bannerWrapper, this.scrollInterval, () =>
                    this.gtmEvent(banner, GTMEventCode.ViewPromotion),
                ),
            1000,
        );
    }

    buttonClicked(banner: AimoCMSBannerComponent): void {
        this.gtmEvent(banner, GTMEventCode.SelectPromotion);
    }

    private gtmEvent(banner: AimoCMSBannerComponent, event: GTMEventCode): void {
        this.gtmService.pushContentEvent(
            this.defineCreativeSlot(banner),
            banner.name,
            GTMContentType.aimo,
            banner.gtmCustomer?.code,
            event,
        );
    }

    private defineCreativeSlot(banner: AimoCMSBannerComponent): GTMCreativeSlot {
        if (banner.bannerType === 'HERO') {
            return GTMCreativeSlot.front_page_hero_banner;
        } else if (banner.bannerType === 'LARGE') {
            return GTMCreativeSlot.front_page_large_banner;
        }
        return GTMCreativeSlot.category_page_vendor_promotion;
    }

    isExternal(data: AimoCMSBannerComponent): boolean | null {
        return data.external === 'true' || data.external === true;
    }

    getTarget(data: AimoCMSBannerComponent): string | null {
        return this.isExternal(data) ? '_blank' : null;
    }

    getSafeUrl(url): SafeUrl {
        return this.safeUrlPipe.transform(url);
    }

    getInternalQueryParams(banner: AimoCMSBannerComponent): Params {
        return {
            promotion_id: banner.uid,
            promotion_name: banner.name,
        };
    }
}
